module.exports = __webpack_public_path__ + "img/v3Banner.90bc33dc.png";